export const NETWORK_STATUS = {
    fail: "failed",
    success: "succeed"
  }